"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const MobilePopover_1 = require("../wizards/components/MobilePopover");
const actions_1 = require("../../actions");
const reducers_1 = require("../../reducers");
const Environment_1 = require("../../Environment");
class UserIconPopover extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            profileMouseEventDirection: 'up',
            settingsMouseEventDirection: 'up',
        };
        this.handleSignOut = this.handleSignOut.bind(this);
        this.closeProfileSettingSelection = this.closeProfileSettingSelection.bind(this);
    }
    componentDidMount() {
        this.props.fetchUser();
    }
    handleSignOut() {
        localStorage.removeItem('ember_simple_auth:session');
        localStorage.removeItem(Environment_1.JUDO_SESSION_KEY);
        window.location.replace('/auth/sign-in');
    }
    closeProfileSettingSelection() {
        const { closePopoverModalForm, device, updateActivePopover } = this.props;
        closePopoverModalForm();
        setTimeout(() => updateActivePopover(''), device === 'Mobile' ? 500 : 0);
    }
    render() {
        const { activePopover, updateActivePopover, device, user, isPopoverModalFormOpen } = this.props;
        const { userName, userEmail, accountName } = user;
        const { profileMouseEventDirection, settingsMouseEventDirection } = this.state;
        const getUserIconInformation = () => (React.createElement("div", { style: {
                width: device !== 'Mobile' ? 384 : '100%',
                paddingLeft: device !== 'Mobile' ? 16 : 24,
                paddingRight: device !== 'Mobile' ? 16 : 24,
                display: 'flex',
                flexDirection: 'column',
            } },
            React.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    height: device !== 'Mobile' ? 80 : 96,
                    borderBottom: `1px solid ${src_1.titanium}`,
                } },
                React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                    React.createElement(src_1.Text, { size: "medium", text: userName }),
                    React.createElement(src_1.Text, { label: true, size: "small", text: userEmail, textStyle: { color: src_1.steel } })),
                device === 'Desktop' && (React.createElement("a", { href: "/settings/overview", style: {
                        textDecoration: 'none',
                        cursor: 'default',
                    }, target: "_blank" },
                    React.createElement("div", { onMouseDown: () => this.setState({
                            profileMouseEventDirection: 'down',
                        }), onMouseUp: () => {
                            this.setState({
                                profileMouseEventDirection: 'up',
                            });
                            this.closeProfileSettingSelection();
                        }, style: {
                            display: 'flex',
                            alignItems: 'center',
                        } },
                        React.createElement(src_1.Text, { text: "Profile", size: "medium", textStyle: {
                                marginRight: 8,
                                fontWeight: 600,
                                color: profileMouseEventDirection === 'up' ? src_1.turquoise : src_1.aquamarine,
                            } }),
                        React.createElement(src_1.ExternalLinkIcon, { fill: profileMouseEventDirection === 'up' ? src_1.turquoise : src_1.aquamarine }))))),
            React.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    height: device !== 'Mobile' ? 56 : 72,
                    borderBottom: device === 'Mobile' ? `1px solid ${src_1.titanium}` : null,
                } },
                React.createElement(src_1.Text, { size: "medium", text: accountName }),
                device === 'Desktop' && (React.createElement("a", { href: "/settings/overview", style: {
                        textDecoration: 'none',
                        cursor: 'default',
                    }, target: "_blank" },
                    React.createElement("div", { onMouseDown: () => this.setState({
                            settingsMouseEventDirection: 'down',
                        }), onMouseUp: () => {
                            this.setState({
                                settingsMouseEventDirection: 'up',
                            });
                            this.closeProfileSettingSelection();
                        }, style: {
                            display: 'flex',
                            alignItems: 'center',
                        } },
                        React.createElement(src_1.Text, { text: "Settings", size: "medium", textStyle: {
                                marginRight: 8,
                                fontWeight: 600,
                                color: settingsMouseEventDirection === 'up' ? src_1.turquoise : src_1.aquamarine,
                            } }),
                        React.createElement(src_1.ExternalLinkIcon, { fill: settingsMouseEventDirection === 'up' ? src_1.turquoise : src_1.aquamarine })))))));
        const navBarProps = {
            buttonLeft: 'Done',
            buttonLeftCallback: this.closeProfileSettingSelection,
            buttonRight: 'Sign Out',
            buttonRightCallback: this.handleSignOut,
            title: device === 'Mobile' ? 'Account' : '',
        };
        return device !== 'Mobile' ? (React.createElement(src_1.PopoverContainer, { id: "user-icon-home-page", popoverProps: {
                placement: device === 'Desktop' ? 'bottom-end' : 'bottom-start',
                navBarProperties: navBarProps,
                arrowColors: {
                    primary: src_1.cloud,
                    secondary: src_1.white,
                    border: src_1.titanium,
                },
            }, onClick: () => activePopover === 'user-icon-home-page-popover'
                ? updateActivePopover('')
                : updateActivePopover('user-icon-home-page-popover'), targetParent: "root", showPopover: activePopover === 'user-icon-home-page-popover' },
            React.createElement(src_1.UserIcon, { fill: src_1.charcoal, height: device === 'Desktop' ? '20' : '24', width: device === 'Desktop' ? '20' : '24', viewBox: "0 0 24 24" }),
            getUserIconInformation())) : (React.createElement("div", { onClick: () => updateActivePopover('user-icon-home-page-popover') },
            React.createElement(src_1.UserIcon, { fill: src_1.charcoal, height: "24", width: "24", viewBox: "0 0 24 24" }),
            activePopover === 'user-icon-home-page-popover' &&
                ReactDOM.createPortal(React.createElement(MobilePopover_1.default, { animation: isPopoverModalFormOpen, navbarProps: navBarProps }, getUserIconInformation()), document.getElementById('root'))));
    }
}
const mapStateToProps = (state) => ({
    activePopover: reducers_1.getActivePopover(state),
    user: reducers_1.getUser(state),
    isPopoverModalFormOpen: reducers_1.getIsPopoverModalFormOpen(state),
});
const mapDispatchToProps = (dispatch) => {
    return {
        updateActivePopover: (activePopover) => dispatch(actions_1.updateActivePopover(activePopover)),
        fetchUser: () => dispatch(actions_1.fetchUser()),
        closePopoverModalForm: () => dispatch(actions_1.closePopoverModalForm()),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(UserIconPopover);
